/**
 * @generated SignedSource<<a3d0437a5a35878dae9b495c15987eb1>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type NavigationProviderIdentityQuery$variables = Record<PropertyKey, never>;
export type NavigationProviderIdentityQuery$data = {
  readonly authIdentity: {
    readonly creditApplications: ReadonlyArray<{
      readonly createdAt: number;
      readonly id: string;
    }>;
    readonly id: string;
    readonly settings: {
      readonly residentialAddress: {
        readonly id: string;
        readonly locality: string;
        readonly primaryAddressLine: string;
        readonly secondaryAddressLine: string | null;
        readonly streetAddress: string;
        readonly subdivision: string;
        readonly zip: string;
      } | null;
    } | null;
  };
};
export type NavigationProviderIdentityQuery = {
  response: NavigationProviderIdentityQuery$data;
  variables: NavigationProviderIdentityQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    v1 = [
      {
        alias: null,
        args: null,
        concreteType: 'Identity',
        kind: 'LinkedField',
        name: 'authIdentity',
        plural: false,
        selections: [
          v0 /*: any*/,
          {
            alias: null,
            args: null,
            concreteType: 'CreditApplication',
            kind: 'LinkedField',
            name: 'creditApplications',
            plural: true,
            selections: [
              v0 /*: any*/,
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'createdAt',
                storageKey: null,
              },
            ],
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'IdentitySetting',
            kind: 'LinkedField',
            name: 'settings',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                concreteType: 'Address',
                kind: 'LinkedField',
                name: 'residentialAddress',
                plural: false,
                selections: [
                  v0 /*: any*/,
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'streetAddress',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'primaryAddressLine',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'secondaryAddressLine',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'locality',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'subdivision',
                    storageKey: null,
                  },
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'zip',
                    storageKey: null,
                  },
                ],
                storageKey: null,
              },
            ],
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: 'Fragment',
      metadata: null,
      name: 'NavigationProviderIdentityQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [],
      kind: 'Operation',
      name: 'NavigationProviderIdentityQuery',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '567e9faaace38af038e429eb86e65b0a',
      id: null,
      metadata: {},
      name: 'NavigationProviderIdentityQuery',
      operationKind: 'query',
      text: 'query NavigationProviderIdentityQuery {\n  authIdentity {\n    id\n    creditApplications {\n      id\n      createdAt\n    }\n    settings {\n      residentialAddress {\n        id\n        streetAddress\n        primaryAddressLine\n        secondaryAddressLine\n        locality\n        subdivision\n        zip\n      }\n    }\n  }\n}\n',
    },
  };
})();

(node as any).hash = '732f52019e37db751fdcbfeb0f6d5dbb';

export default node;
